class HeaderSearch extends HTMLElement {
  constructor() {
    super();

    this.buildProductObject(); // Default Products & List
    this.cachedResults = {};
    this.isOpen = false;
    this.controller = null;
    this.isMobile = window.innerWidth < 1025 ? true : false;
    this.buildSelectors();
    if (!this.isMobile) this.setModalPosition();
    this.setupEventListeners();
    this.initialRender(false);
  }

  setModalPosition() {
    this.isMobile = window.innerWidth < 1025 ? true : false;
    const modelData = this.getResultsMaxHeight();
    if (this.isMobile) {
      this.model.style.setProperty('--modelTopPos', modelData.announcementBottom + 'px');
      this.model.style.setProperty('--modelMaxHeight', '100vh');
      this.predictiveSearchResults.style.setProperty('--productContainerMaxHeight', '100%');
    } else {
      const productContainerMaxHeight = window.innerHeight - modelData.modelTopPos - 140;
      this.model.style.setProperty('--modelTopPos', modelData.modelTopPos + 'px');
      this.model.style.setProperty('--modelMaxHeight', modelData.modelMaxHeight + 'px');
      this.predictiveSearchResults.style.setProperty(
        '--productContainerMaxHeight',
        productContainerMaxHeight + 'px'
      );
    }
  }

  buildProductObject() {
    const defaultConfig = window._theme.headerSearch || null;
    if (!defaultConfig) return;
    this.defaultConfig = defaultConfig;
    this.defaultConfig.defaultProducts = this.defaultConfig.defaultProducts || [];
    this.defaultConfig.defaultProducts = this.defaultConfig.defaultProducts.map((product) => {
      const product_url = `/products/${product.handle}`;
      const variants = product.variants.map((variant, index) => {
        // Ensure metafield data is properly structured
        const metafieldValue =
          variant.metafields &&
          variant.metafields.custom &&
          variant.metafields.custom.brightperl_variant_inventory
            ? variant.metafields.custom.brightperl_variant_inventory
            : '';

        const expressShippingAllow =
          variant.metafields &&
          variant.metafields.custom &&
          variant.metafields.custom.allow_express_shipping
            ? variant.metafields.custom.allow_express_shipping
            : '';

        return {
          ...variant,
          available: variant.available ? '1' : '0',
          image_alt: variant.featured_image ? variant.featured_image.alt : '',
          image_link: variant.featured_image ? variant.featured_image.src : '',
          link: `${product_url}?variant=${variant.id}`,
          list_price: variant.compare_at_price ? variant.compare_at_price / 100 : null,
          price: variant.price / 100,
          quantity_total: variant.inventory_quantity || 0,
          sku: variant.sku || '',
          taxable: variant.taxable ? '1' : '0',
          variant_id: variant.id,
          // Add the metafield data structure that the shipping-info component expects
          search_variant_metafields_data: {
            variant_metafield_69f1d8722b9c470908fa53fe850945fb: metafieldValue,
            variant_metafield_070071a13a8ea5aafeb0b99afa0c101f: expressShippingAllow,
          },
        };
      });

      return {
        ...product,
        product_id: product.id,
        link: `/products/${product.handle}`,
        image_link: product.featured_image,
        shopify_images: product.images || [],
        tags: product.tags.join('[:ATTR:]'),
        list_price: product.compare_at_price / 100,
        price: product.price / 100,
        shopify_variants: variants,
      };
    });

    this.defaultConfig.defaultProducts = this.defaultConfig.defaultProducts.filter(
      (p) => p.available
    );

    delete window._theme.headerSearch;
  }

  buildSelectors() {
    this.model = this.querySelector('[data-ajax-search-results]');
    this.input = this.querySelector('input[data-header-search]');
    this.form = this.input.closest('form');
    this.formResetBtn = this.form.querySelector('[type="reset"]');
    this.predictiveSearchResults = this.querySelector('[data-search-products]');
    this.predictiveSearchViewAllBtns = this.querySelectorAll('[data-search-view-all]');
    this.overlay = document.querySelector('.wrapper-overlay');
    this.closeSearchBtns = this.querySelectorAll('[data-close-search]');

    this.trendingSearcheList = this.querySelectorAll('[data-list-trending-searches]');
    this.brandsList = this.querySelectorAll('[data-list-brands]');
    this.suggestionList = this.querySelectorAll('[data-list-suggestions]');
    this.pagesList = this.querySelectorAll('[data-list-pages]');

    this.noResultTextNodes = this.querySelectorAll('[data-noresult-block] span');
    this.searchIcon = document.querySelector('.site-header .head-search input[name="head-search"]');
    this.statusElement = this.statusElement || this.form.querySelector('.predictive-search-status');
  }

  setupEventListeners() {
    const self = this;
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.form.addEventListener('reset', (evt) => {
      this.setAttribute('data-result', false);
      this.initialRender(false);
      this.close();
      if (this.controller) this.controller.abort();
    });

    this.closeSearchBtns.forEach((btn) => {
      btn.addEventListener('click', function (evt) {
        self.close(true);
      });
    });

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    // this.addEventListener('blur', this.onFocusOut.bind(this));

    this.predictiveSearchViewAllBtns.forEach((btn) => {
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        const term = this.getQuery();
        window.location.href = '/search?q=' + encodeURIComponent(term);
      });
    });

    // this.addEventListener('keyup', this.onKeyup.bind(this));
    // this.addEventListener('keydown', this.onKeydown.bind(this));
    if (this.isMobile) {
      this.searchIcon.addEventListener('focus', (evt) => {
        evt.preventDefault();
        this.open();
        this.input.focus();
      });
    }

    if (!this.isMobile) {
      window.onresize = debounce((evt) => {
        this.setModalPosition();
      });
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange(event) {
    this.input.removeAttribute('aria-invalid');
    this.removeAttribute('data-empty');
    const searchTerm = this.getQuery();
    this.noResultTextNodes.forEach((elem) => (elem.innerHTML = '\"' + searchTerm + '\"'));
    this.form.querySelector('input[name="q"]').value = searchTerm;
    if (!searchTerm.length) {
      this.setAttribute('data-result', false);
      this.initialRender();
      this.setLiveRegionText('found top trending searches & prodducts');
      return;
    }

    this.setAttribute('data-result', true);
    this.getSearchResults(searchTerm, event);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a'))
      event.preventDefault();
  }

  onFocus(event) {
    this.open();
    const searchTerm = this.getQuery();
    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm, event);
    }
  }

  onFocusOut(evt) {
    const isInsideModal = this.contains(evt.target);
    const isRelatedTargetInsideModal = evt.relatedTarget ? this.contains(evt.relatedTarget) : true;

    setTimeout(() => {
      if (!isInsideModal || !isRelatedTargetInsideModal) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector(
      '[aria-selected="true"] a, [aria-selected="true"] button'
    );

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm, event) {
    const queryKey = searchTerm.toLowerCase();
    this.setLiveRegionLoadingState();

    const cachedRes = this.cachedResults[queryKey];
    if (cachedRes) {
      if (cachedRes.totalItems === 0) this.renderEmptyResult(cachedRes, event);
      else this.renderSearchResults(cachedRes);
      return;
    }

    if (this.controller) this.controller.abort();

    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.form.setAttribute('data-loading', true);
    const maxSuggestion = 5;

    const menTags = ['gender_Men', 'GENDER_Men', 'Gender_Men', 'Gender_men', 'gender_men'];
    const womenTags = ['Gender_Women', 'gender_women', 'GENDER_Women', 'gender_Women'];
    let tagQuery = '';
    const searchTerms = queryKey ? queryKey.trim().toLowerCase().split(' ') : [];
    if (searchTerms.includes('women') || searchTerms.includes('woman'))
      tagQuery = '&restrictBy[snize_facet1]=' + womenTags.join('|');
    else if (searchTerms.includes('men') || searchTerms.includes('man'))
      tagQuery = '&restrictBy[snize_facet1]=' + menTags.join('|');
    else tagQuery = '';

    const BASE_URL =
      'https://searchserverapi.com/getwidgets?api_key=2K7F7z9Y9V&output=jsonp&items=true&maxResults=8&suggestions=true&suggestionsMaxResults=' +
      maxSuggestion +
      '&pages=true&pagesMaxResults=10&categories=true&categoryStartIndex=0&categoriesMaxResults=5' +
      tagQuery; // restrictBy%5Bquantity%5D=1%7C&

    fetch(`${BASE_URL}&q=${encodeURIComponent(searchTerm)}`, { signal })
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.json();
      })
      .then((res) => {
        this.cachedResults[queryKey] = res;
        if (res.totalItems === 0) this.renderEmptyResult(res, event);
        else this.renderSearchResults(res);
        this.controller = null;
      })
      .catch((error) => {
        // this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.form.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  initialRender(openModel = true) {
    if (!this.defaultConfig) return;
    this.setAttribute('data-result', false);
    let trendingSearchesHtml = '',
      productsHtml = '';

    if (this.defaultConfig.defaultSuggestions.length)
      trendingSearchesHtml = this.buildSuggestionList(this.defaultConfig.defaultSuggestions);

    if (this.defaultConfig.defaultProducts.length)
      productsHtml = this.buildProductGrid(
        this.defaultConfig.defaultProducts.slice(0, 10),
        this.defaultConfig.productTypes.slice(0, 10)
      );

    if (trendingSearchesHtml !== '') {
      this.trendingSearcheList.forEach((list) => {
        list
          .closest('.search-result-col-row')
          .classList.toggle('hidden', trendingSearchesHtml === '');
        list.innerHTML = trendingSearchesHtml;
      });
    }

    if (productsHtml !== '') this.predictiveSearchResults.innerHTML = productsHtml;
    this.predictiveSearchViewAllBtns.forEach((btn) => {
      btn.classList.add('hidden');
    });
    this.form.removeAttribute('data-loading');
    if (openModel) this.open();
  }

  renderSearchResults(res) {
    if (!res.totalItems || res.totalItems === 0) return;
    this.removeAttribute('data-empty');
    const totalProducts = res.totalItems;
    const brandsHtml = this.buildBrandsList(res.categories);
    const suggestionsHtml = this.buildSuggestionList(res.suggestions);
    const trendingSearchesHtml = this.buildSuggestionList(this.defaultConfig.defaultSuggestions);
    const pagesHtml = this.buildPagesList(res.pages);
    const productsHtml = this.buildProductGrid(res.items.slice(0, 12));

    // Left :: List
    this.brandsList.forEach((list) => {
      list.closest('.search-result-col-row').classList.toggle('hidden', brandsHtml === '');
      list.innerHTML = brandsHtml;
    });

    this.suggestionList.forEach((list) => {
      list.closest('.search-result-col-row').classList.toggle('hidden', suggestionsHtml === '');
      list.innerHTML = suggestionsHtml;
    });

    this.trendingSearcheList.forEach((list) => {
      list
        .closest('.search-result-col-row')
        .classList.toggle('hidden', trendingSearchesHtml === '');
      list.innerHTML = trendingSearchesHtml;
    });

    this.pagesList.forEach((list) => {
      list.closest('.search-result-col-row').classList.toggle('hidden', pagesHtml === '');
      list.innerHTML = pagesHtml;
    });

    // Right :: Products
    this.predictiveSearchResults.innerHTML = productsHtml;

    this.setAttribute('results', true);
    this.setLiveRegionResults(totalProducts);

    this.predictiveSearchViewAllBtns.forEach((btn) => {
      btn.innerHTML = 'View All ' + totalProducts + ' Products';
      if (totalProducts > 8) btn.classList.remove('hidden');
      else btn.classList.add('hidden');
    });

    this.form.removeAttribute('data-loading');
    this.open();
  }

  renderEmptyResult(res, event) {
    if (event && event.type !== 'focus') {
      const searchTerm = this.getQuery();
      _theme.track.trackData({ event: 'zero_search_dropdown', search_term: searchTerm });
    }
    this.input.setAttribute('aria-invalid', true);
    this.setLiveRegionText('Sorry, nothing found for the search term ' + this.getQuery());
    this.setAttribute('data-empty', true);
    this.initialRender(false);
  }

  updateHtml(html, str, data) {
    let newhtml = html;
    if (newhtml.indexOf(str) > -1) {
      newhtml = newhtml.replace(str, data);
      return this.updateHtml(newhtml, str, data);
    } else {
      return newhtml;
    }
  }

  buildBrandsList(brands) {
    if (!brands || brands.length === 0) return '';
    // const self = this;
    let mainHtml = '<ul class="brand-list" role="list">';
    brands.slice(0, 1).forEach(function (brand) {
      // const dots = brand.title.length > 20 ? '...' : '';
      // const title = self.isMobile ? brand.title : brand.title.slice(0,20) + dots;

      if (brand.image_link != '') {
        var brand_content = `<span class="brand-img"><img src="${brand.image_link}" alt="${brand.title}"></span>`;
      } else {
        var brand_content = `<span class="brand-title">${brand.title}</span>`;
      }

      mainHtml +=
        '<li class="brand-item" role="listitem"><a href="' +
        brand.link +
        '">' +
        brand_content +
        '<span class="see-all">See all products</span></a></li>';
    });

    return mainHtml;
  }

  buildSuggestionList(suggestions) {
    if (!suggestions || suggestions.length === 0) return '';
    let mainHtml = '<ul role="list">';
    suggestions.slice(0, 3).forEach(function (suggestion) {
      mainHtml +=
        '<li role="listitem"><a class="outline-inset" href="' +
        window.routes.search_url +
        '?q=' +
        encodeURI(suggestion) +
        '">' +
        suggestion +
        '</a></li>';
    });

    return mainHtml;
  }

  buildPagesList(pages) {
    if (!pages || pages.length === 0) return '';
    const pagesArr = pages.filter((page) => page.link.includes('/blogs/')).slice(0, 3);
    if (pagesArr.length === 0) return '';
    let mainHtml = '<ul role="list">';
    pagesArr.forEach(function (page) {
      mainHtml +=
        '<li role="listitem"><a class="outline-inset" href="' +
        page.link +
        '">' +
        page.title +
        '</a></li>';
    });

    return mainHtml;
  }

  isTimerActive(timerSettings) {
    // Only consider timer active if enabled is true or 'True', everything else is false
    const enabled = timerSettings.enabled;
    if (enabled !== true && enabled !== 'True') {
      return false;
    }

    // Check if required date/time fields are present
    if (
      !timerSettings.startDate ||
      !timerSettings.startTime ||
      !timerSettings.endDate ||
      !timerSettings.endTime
    ) {
      return false;
    }

    const startDateTime = _theme.Helpers.parseESTDate(
      timerSettings.startDate,
      timerSettings.startTime
    ).getTime();
    const endDateTime = _theme.Helpers.parseESTDate(
      timerSettings.endDate,
      timerSettings.endTime
    ).getTime();
    const currentTime = _theme.Helpers.getCurrentESTTime();

    const isActive = currentTime >= startDateTime && currentTime <= endDateTime;

    return isActive;
  }

  buildProductGrid(products, productTypes) {
    if (!products || products.length === 0) return '';
    const self = this;
    let mainHtml = '';
    products.map(function (product, productIndex) {
      let product_html = _theme.product_html.productGridHeaderSearch;
      let vid = '';
      const variant = product.shopify_variants.filter(function (v) {
        return JSON.parse(v.available);
      })[0];

      const variant_barcode_available = product.shopify_variants
        .filter((variant) => {
          return variant.available == true || variant.available == 1 || variant.available == '1';
        })
        .map((variant) => ({
          available: variant.available, // Optional (since we already filtered)
          brightperlInventory:
            variant?.search_variant_metafields_data
              ?.variant_metafield_69f1d8722b9c470908fa53fe850945fb,
          allowExpressShipping:
            variant?.search_variant_metafields_data
              ?.variant_metafield_070071a13a8ea5aafeb0b99afa0c101f,
        }));

      const maxDiscountData = getMaxDiscountAndvariant(product);
      const productUrl =
        (maxDiscountData.availableMaxDiscountVariant &&
          maxDiscountData.availableMaxDiscountVariant.link) ||
        product.link;

      if (!variant) vid = product.shopify_variants[0].variant_id;
      else vid = variant.variant_id;
      let prodType = '';
      if (product.metafield_9e14d49086f4ac1134f463aa2738d80e !== undefined) {
        prodType = product.metafield_9e14d49086f4ac1134f463aa2738d80e;
      } else if (product.product_type !== undefined) {
        prodType = product.product_type;
      }

      if (productTypes) {
        prodType = productTypes[productIndex] !== undefined ? productTypes[productIndex] : '';
      }
      product_html = self.updateHtml(product_html, '[[Product_Id]]', product.product_id);
      // Safely update shipping info variants with error handling

      product_html = self.updateHtml(
        product_html,
        '[[shipping_info_variants]]',
        JSON.stringify(variant_barcode_available)
      );
      product_html = self.updateHtml(product_html, '[[Product_Title]]', product.title);
      product_html = self.updateHtml(product_html, '[[Product_Type]]', prodType);
      product_html = self.updateHtml(product_html, '[[Variant_Id]]', vid);
      product_html = self.updateHtml(product_html, '[[Product_URL]]', productUrl);
      let featured_image =
        product.image_link ||
        'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
      let secondaryImg = null;
      featured_image += featured_image.indexOf('?') === -1 ? '?width=200' : '&width=200';

      if (product.shopify_images && product.shopify_images.length > 1) {
        secondaryImg = product.shopify_images[1];
        secondaryImg += secondaryImg.indexOf('?') === -1 ? '?width=200' : '&width=200';
      }

      const image =
        "<img sizes='200' data-sizes='200' loading='lazy' src='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==' data-src='" +
        featured_image +
        "' alt='' class='lazyload' />";
      product_html = self.updateHtml(product_html, '[[Product_Image_1]]', image);
      if (product.shopify_images && product.shopify_images.length > 1) {
        const image_2 =
          "<span class='images-two'><img sizes='200' data-sizes='200' src='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==' data-src='" +
          secondaryImg +
          "' alt='" +
          product.title +
          "' class='lazyload' loading='lazy' /></span>";
        product_html = self.updateHtml(product_html, '[[Product_Image_2]]', image_2);
        product_html = self.updateHtml(product_html, '[[Image_1_Class]]', 'images-one');
      } else {
        product_html = self.updateHtml(product_html, '[[Image_1_Class]]', '');
        product_html = self.updateHtml(product_html, '[[Product_Image_2]]', '');
      }

      const p_html = buildDiscountLabel(product);

      // if(productIndex <= 1 ){
      //   const checkForLabels = buildLabels(product);
      //   if(checkForLabels){
      //     product_html = self.updateHtml(product_html, '[[Product_Custom_Label]]', "");
      //   }else{
      //     product_html = self.updateHtml(product_html, '[[Product_Custom_Label]]', buildCustomLabel());
      //   }
      // }else{
      //   product_html = self.updateHtml(product_html, '[[Product_Custom_Label]]', "");
      // }

      product_html = self.updateHtml(product_html, '[[Product_Vendor]]', product.vendor || '');
      product_html = self.updateHtml(
        product_html,
        '[[Product_Vendor_Url]]',
        '/collections/' + self.handleize(product.vendor) || ''
      );
      product_html = self.updateHtml(
        product_html,
        '[[Product_Handle]]',
        product.link.replace('/products/', '')
      );
      product_html = self.updateHtml(product_html, '[[Grid_Class]]', buildGridClass(product));
      product_html = self.updateHtml(product_html, '[[Product_Price]]', buildPrice(product));
      product_html = self.updateHtml(product_html, '[[Product_Labels]]', buildLabels(product));
      product_html = self.updateHtml(
        product_html,
        '[[Product_PriceOff_Label]]',
        buildPriceOffLabels(product)
      );
      product_html = self.updateHtml(product_html, '[[Product_Notify_CTA]]', '');
      product_html = self.updateHtml(product_html, '[[Product_Quick_Add_Swatch]]', '');
      if (typeof p_html === 'string') {
        product_html = self.updateHtml(product_html, '[[Product_Bogo_Label]]', p_html);
        product_html = self.updateHtml(product_html, '[[MIXMATCH_CLASS]]', '');
      } else {
        product_html = self.updateHtml(product_html, '[[Product_Bogo_Label]]', p_html.html);
        product_html = self.updateHtml(
          product_html,
          '[[MIXMATCH_CLASS]]',
          p_html.mixmatch ? 'has-mixmatch' : ''
        );
      }

      mainHtml += product_html;
    });

    function buildLabels(product) {
      if (!product.tags || product.tags === '') return '';
      const html = '';
      const tagsStr = product.tags.trim().toLowerCase();
      const variant = product.shopify_variants.filter(function (v) {
        return JSON.parse(v.available);
      })[0];

      return html;
    }

    function buildPriceOffLabels(product) {
      let hasBogo = false;
      let has2for75 = false;
      let has2for25 = false;
      let has3for20 = false;
      let isOnlineOnly = false;
      let hasBestSeller = false;
      let flashSale = false;
      let offerCount = 1;
      let offerHtmlTag = '';
      let checkSold = false;
      let dynamicOfferClass = '';

      let priceHtml = '';
      let labelHtml = '';

      const checkvariant = product.shopify_variants.filter(function (v) {
        return JSON.parse(v.available);
      })[0];

      if (!checkvariant) checkSold = true;

      // Only show offer badges if at least one variant is offer-applicable AND in stock
      const hasOfferVariant = product.shopify_variants?.some(
        (variant) =>
          variant.search_variant_metafields_data
            ?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === 'true' &&
          variant.available !== '0'
      );

      // Check if timer is active and flash sale extension shop metafield is active
      const timerSettings = window.countdownTimerSettings || {};
      const isTimerActive = self.isTimerActive(timerSettings);
      const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;

      // Filter variants that have flash sale metafield with value 'true' and are available
      const flashVariants = product.shopify_variants.filter(
        (variant) =>
          variant.search_variant_metafields_data
            ?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
          variant.available !== '0'
      );

      if (product.tags && product.tags !== '') {
        const tagsStr = product.tags.trim().toLowerCase();
        const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;

        // Check if any flash variant exists and timer is active and flash sale extension shop metafield is active
        if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
          dynamicOfferClass = 'offer-tag-style flash-sale';
          offerCount = 2;
          const startDate = timerSettings.startDate || '';
          const startTime = timerSettings.startTime || '';
          const endDate = timerSettings.endDate || '';
          const endTime = timerSettings.endTime || '';

          offerHtmlTag = `<div><img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/flash-sale.svg?v=1753779044' alt=''> <span class=''>Flash sale</span> <span class='flash-separator' aria-hidden='true'><svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='4' cy='4' r='1' fill='#C75300'/></svg></span> <countdown-timer data-start-date='${startDate}' data-start-time='${startTime}' data-end-date='${endDate}' data-end-time='${endTime}' data-location='product-grid' role='timer' aria-label='Flash sale countdown timer'><span class='flash-timer-text'>00:00:00</span></countdown-timer></div>`;
          flashSale = true;
        } else if (offerCount < 2 && hasOfferVariant && productOffer === 'BOGO 50') {
          dynamicOfferClass = 'bogo-50';
          hasBogo = true;
          offerCount = 2;
          offerHtmlTag = `<img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/offer.svg?v=1722427324' alt=''> BOGO 50 - Mix & Match`;
        } else if (offerCount < 2 && hasOfferVariant && productOffer === '2 For $75') {
          dynamicOfferClass = 'two-for-75';
          has2for75 = true;
          offerCount = 2;
          offerHtmlTag = `<img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/offer.svg?v=1722427324' alt=''> 2 for $75 - Mix & Match`;
        } else if (offerCount < 2 && hasOfferVariant && productOffer === '2 For $25') {
          dynamicOfferClass = 'two-for-25';
          has2for25 = true;
          offerCount = 2;
          offerHtmlTag = `<img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/offer.svg?v=1722427324' alt=''> 2 for $25 - Mix & Match`;
        } else if (offerCount < 2 && hasOfferVariant && productOffer === '3 For $20') {
          dynamicOfferClass = 'three-for-20';
          has3for20 = true;
          offerCount = 2;
          offerHtmlTag = `<img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/offer.svg?v=1722427324' alt=''> 3 for $20 - Mix & Match`;
        } else if (offerCount < 2 && hasOfferVariant && productOffer === '3 For $99') {
          dynamicOfferClass = 'three-for-99';
          offerCount = 2;
          offerHtmlTag = `<img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/offer.svg?v=1722427324' alt=''> 3 for $99 - Mix & Match`;
        } else if (offerCount < 2 && tagsStr.includes('online-only-item')) {
          dynamicOfferClass = 'online-only';
          isOnlineOnly = true;
          offerCount = 2;
          offerHtmlTag = `<img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/Group_2469.svg?v=1724309634' alt=''> Online Only`;
        } else if (offerCount < 2 && tagsStr.includes('best-sellers')) {
          dynamicOfferClass = 'best-sellers';
          hasBestSeller = true;
          offerCount = 2;
          offerHtmlTag = `<img loading='lazy' src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/Best_Seller_Tag.svg?v=1722427276' alt=''> Best Seller`;
        }
      }

      const maxDiscountData = getMaxDiscountAndvariant(product);
      const variant = maxDiscountData.maxDiscountVariant;

      // Check if any flash variant exists and timer is active and flash sale extension shop metafield is active
      if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
        const per = Math.round(
          parseFloat(flashVariants[0].list_price) - parseFloat(flashVariants[0].price)
        );
        priceHtml = `<div class="price-regular flash-sale-price"> 
              <span class="custom-discount" data-old-price="${flashVariants[0].list_price}" data-current-price="${flashVariants[0].price}">
                  <span class="visually-hidden">$${per} Off</span>
                  <span class="text" aria-hidden="true">
                      <img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/dollar_sign.png?v=1753881211'  alt='' /> 
                      $${per} Off
                  </span>
              </span>
          </div>`;
      } else if (variant && maxDiscountData.maxDiscount) {
        const per = maxDiscountData.maxDiscount;
        priceHtml = `<div class="price-regular">
                              <span class="custom-discount" data-old-price="${variant.list_price}" data-current-price="${variant.price}">
                                  <span class="visually-hidden">Up to $${per} Off</span>
                                  <span class="text" aria-hidden="true">
                                      <img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/offer.svg?v=1722427324' alt='' /> 
                                      Up to $${per} Off
                                  </span>
                              </span>
                          </div>`;
      }

      if (offerHtmlTag) {
        labelHtml = `<span class="custom-discount-offer ${dynamicOfferClass}">${offerHtmlTag}</span>`;
      }

      return priceHtml !== '' || labelHtml !== ''
        ? `<div class="price-box"><div class="price-regular">${priceHtml}${labelHtml}</div></div>`
        : '';
    }

    // function buildCustomLabel(){

    //   let html = '';

    //   const customLabelString =  `<div class="customOffLabelText">Bestseller</div>`
    //   html += customLabelString;

    //   return html;

    // }

    function buildDiscountLabel(product) {
      if (!product.tags || product.tags === '') return '';

      const html = '';
      const tagsStr = product.tags.trim().toLowerCase();
      // if(tagsStr.includes('bundle-2-for-75')) return html;

      // if(tagsStr.includes('bogo-discount') && !tagsStr.includes('discount-amount:')){
      //   html = '';
      // }

      return html;
    }

    function buildPrice(product) {
      let isSoldOut = false;
      const variant = product.shopify_variants.filter(function (v) {
        return v.available != '0';
      })[0];
      const prices = product.shopify_variants.map(function (v) {
        return Number(v.price);
      });
      if (!variant) isSoldOut = true;

      const price = Shopify.formatMoney(product.price * 100, window.money_format);
      let html =
        '<div class="sale-price pink_color"><span class="visually-hidden">Sale price ' +
        price +
        '</span><span aria-hidden="true">' +
        price +
        '</span></div>';
      if (prices.length > 1) {
        const min_price = Math.min.apply(null, prices);
        const max_price = Math.max.apply(null, prices);
        if (min_price !== max_price) {
          const min_price_formatted = Shopify.formatMoney(min_price * 100, window.money_format);
          const max_price_formatted = Shopify.formatMoney(max_price * 100, window.money_format);
          html =
            '<div class="sale-price pink_color"><span class="visually-hidden">Price range from ' +
            min_price_formatted +
            ' to ' +
            max_price_formatted +
            '</span><span aria-hidden="true">' +
            min_price_formatted +
            ' - ' +
            max_price_formatted +
            '</span></div>';
        }
      }

      // if(isSoldOut) html = '';
      return html;
    }

    function buildGridClass(product) {
      let html = '';
      const available_v = product.shopify_variants.filter(function (v) {
        return v.available != '0';
      });
      if (available_v.length) html = 'available';
      else html = 'sold_out';

      return html;
    }

    function getMaxDiscountAndvariant(product) {
      let maxDiscount = 0,
        maxDiscountVariant = null;
      let availableMaxDiscount = 0,
        availableMaxDiscountVariant = null;
      product.shopify_variants &&
        product.shopify_variants.length > 0 &&
        product.shopify_variants.forEach(function (v) {
          const maxPrice = Number(v.list_price);
          if (!maxPrice || maxPrice <= 0) return false;
          const price = Number(v.price);
          const discountPer = Math.ceil(maxPrice - price);
          if (discountPer > maxDiscount) {
            maxDiscount = discountPer;
            maxDiscountVariant = v;
          }
          if (discountPer > availableMaxDiscount && Number(v.available)) {
            availableMaxDiscount = discountPer;
            availableMaxDiscountVariant = v;
          }
        });

      const discountAmt = Number(product.discount);
      const productListPrice = Number(product.list_price);
      if (!maxDiscount && discountAmt > 0 && productListPrice > 0) {
        const per = Math.floor(((product.list_price - product.price) * 100) / product.list_price);
        maxDiscount = discountAmt || per;
      }

      return {
        maxDiscount: maxDiscount,
        maxDiscountVariant: maxDiscountVariant,
        availableMaxDiscount: availableMaxDiscount,
        availableMaxDiscountVariant: availableMaxDiscountVariant,
      };
    }

    return mainHtml;
  }

  handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '');
  }

  setLiveRegionResults(totalProducts) {
    const searchTerm = this.getQuery();
    this.removeAttribute('loading');
    this.setLiveRegionText(totalProducts + ' products found for the search term ' + searchTerm);
  }

  getResultsMaxHeight() {
    const announcementBottom = document
      .getElementById('shopify-section-announcement-bar')
      .getBoundingClientRect().bottom;
    const modelTopPos = document
      .getElementById('shopify-section-header-new')
      .getBoundingClientRect().bottom;
    this.resultsMaxHeight = window.innerHeight - modelTopPos;
    return {
      modelMaxHeight: this.resultsMaxHeight,
      modelTopPos: modelTopPos,
      announcementBottom: announcementBottom,
    };
  }

  open() {
    const self = this;
    document.body.classList.add('search-active', 'overflow-hidden');
    this.formResetBtn.setAttribute('tabindex', 0);
    this.setAttribute('open', true);
    // this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    if (!this.isMobile) this.setModalPosition();
    _theme.focusTrap(
      $(this),
      () => {
        this.close(true);
      },
      null,
      true
    );
  }

  close(clearSearchTerm) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.removeAttribute('open');
    this.input.setAttribute('aria-activedescendant', '');
    // this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
    document.body.classList.remove('search-active', 'overflow-hidden');
    this.form.removeAttribute('data-loading');
    this.formResetBtn.setAttribute('tabindex', -1);
    this.isOpen = false;
  }
}

window.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 1025) {
    const hsw = document.querySelector('.site-header .head-search');
    const hs = document.querySelector('header-search');
    hsw && hs && hsw.append(hs);
  }
  customElements.define('header-search', HeaderSearch);
});
